export default {
  search: null,
  client: "",
  changeDistributor: false,
  fetchClients: false,
};
